module.exports = ".container-cliente {\n  margin-top: 10px; }\n\n.btn-primary-clientes {\n  font-size: 25px;\n  text-align: center;\n  padding: 10px 15px;\n  width: 100%; }\n\n::ng-deep main {\n  height: 100%;\n  /* Firefox */\n  height: 100%;\n  /* Chrome, Safari */\n  height: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/cliente/contenedor-cliente/contenedor-cliente.component.scss
// module id = ./src/app/components/cliente/contenedor-cliente/contenedor-cliente.component.scss
// module chunks = main